import SLS02_011RPT from "@/views/MISALE/SLS02_011RPT.vue";
import SLS02_021RPT from "@/views/MISALE/SLS02_021RPT.vue";
import SLS02_030RPT from "@/views/MISALE/SLS02_030RPT.vue";
import SLS02_014RPT from "@/views/MISALE/SLS02_014RPT.vue";
import SLS06_002RPT from "@/views/MISALE/SLS06_002RPT.vue";
import SLS06_004RPT from "@/views/MISALE/SLS06_004RPT.vue";
import SLS05_002RPT from "@/views/MISALE/SLS05_002RPT.vue";
import SLS05_004RPT from "@/views/MISALE/SLS05_004RPT.vue";
import SLS04_003RPT from "@/views/MISALE/SLS04_003RPT.vue";
import SLS04_002RPT from "@/views/MISALE/SLS04_002RPT.vue";
import SLS04_031RPT from "@/views/MISALE/SLS04_031RPT.vue";
import SLS06_001RPT from "@/views/MISALE/SLS06_001RPT.vue";
import SLS04_004RPT from "@/views/MISALE/SLS04_004RPT.vue";
import SLS06_005RPT from "@/views/MISALE/SLS06_005RPT.vue";
import SLS02_017RPT from "@/views/MISALE/SLS02_017RPT.vue";
import SLS02_028RPT from "@/views/MISALE/SLS02_028RPT.vue";
import SLS06_003RPT from "@/views/MISALE/SLS06_003RPT.vue";
import SLS08_001RPT from "@/views/MISALE/SLS08_001RPT.vue";
import SLS08_002RPT from "@/views/MISALE/SLS08_002RPT.vue";
import SLS08_003RPT from "@/views/MISALE/SLS08_003RPT.vue";
import SLS08_004RPT from "@/views/MISALE/SLS08_004RPT.vue";
import SLS08_005RPT from "@/views/MISALE/SLS08_005RPT.vue";
import SLS11_007RPT from "@/views/MISALE/SLS11_007RPT.vue";
import SLS11_006RPT from "@/views/MISALE/SLS11_006RPT.vue";
import SLS11_013RPT from "@/views/MISALE/SLS11_013RPT.vue";
import SLS11_009RPT from "@/views/MISALE/SLS11_009RPT.vue";
import SLS11_012RPT from "@/views/MISALE/SLS11_012RPT.vue";
import SLS11_014RPT from "@/views/MISALE/SLS11_014RPT.vue";
import SLS11_004RPT from "@/views/MISALE/SLS11_004RPT.vue";
import SLS11_008RPT from "@/views/MISALE/SLS11_008RPT.vue";
import SLS12_011RPT from "@/views/MISALE/SLS12_011RPT.vue";
import SLS12_019RPT from "@/views/MISALE/SLS12_019RPT.vue";
import SLS12_020RPT from "@/views/MISALE/SLS12_020RPT.vue";
import SLS14_032RPT from "@/views/MISALE/SLS14_032RPT.vue";
import SLS01_091RPT from "@/views/MISALE/SLS01_091RPT.vue";
import SLS01_092RPT from "@/views/MISALE/SLS01_092RPT.vue";
import SLS02_006RPT from "@/views/MISALE/SLS02_006RPT.vue";
import SLS02_022RPT from "@/views/MISALE/SLS02_022RPT.vue";
import SLS01_093RPT from "@/views/MISALE/SLS01_093RPT.vue";
import SLS01_055RPT from "@/views/MISALE/SLS01_055RPT.vue";
import SLS01_056RPT from "@/views/MISALE/SLS01_056RPT.vue";
import SLS01_057RPT from "@/views/MISALE/SLS01_057RPT.vue";
import SLS02_023RPT from "@/views/MISALE/SLS02_023RPT.vue";
import SLS01_001INS from "@/views/MISALE/SLS01_001INS.vue";
import SLS02_031RPT from "@/views/MISALE/SLS02_031RPT.vue";
import SLS07_006INS from "@/views/MISALE/SLS07_006INS.vue";
import SLS11_010RPT from "@/views/MISALE/SLS11_010RPT.vue";
import SLS11_011RPT from "@/views/MISALE/SLS11_011RPT.vue";
import SLS11_017RPT from "@/views/MISALE/SLS11_017RPT.vue";
import SLS02_032RPT from "@/views/MISALE/SLS02_032RPT.vue";
import SLS04_027RPT from "@/views/MISALE/SLS04_027RPT.vue";
import SLS11_024RPT from "@/views/MISALE/SLS11_024RPT.vue";
import SLS11_025RPT from "@/views/MISALE/SLS11_025RPT.vue";
import SLS04_023RPT from "@/views/MISALE/SLS04_023RPT.vue";
import SLS11_021RPT from "@/views/MISALE/SLS11_021RPT.vue";
import SLS12_002RPT from "@/views/MISALE/SLS12_002RPT.vue";
import SLS14_004RPT from "@/views/MISALE/SLS14_004RPT.vue";
import SLS14_043RPT from "@/views/MISALE/SLS14_043RPT.vue";
import SLS14_044RPT from "@/views/MISALE/SLS14_044RPT.vue";
import SLS11_023RPT from "@/views/MISALE/SLS11_023RPT.vue";
import SLS02_007RPT from "@/views/MISALE/SLS02_007RPT.vue";
import SLS02_008RPT from "@/views/MISALE/SLS02_008RPT.vue";
import SLS16_001RPT from "@/views/MISALE/SLS16_001RPT.vue";
import SLS16_002RPT from "@/views/MISALE/SLS16_002RPT.vue";
import SLS06_013RPT from "@/views/MISALE/SLS06_013RPT.vue";

export default function salesRouter() {
  return [
    {
      path: "SLS02_011RPT.xml",
      component: SLS02_011RPT,
    },

    {
      path: "SLS02_021RPT.xml",
      component: SLS02_021RPT,
    },
    {
      path: "SLS02_030RPT.xml",
      component: SLS02_030RPT,
    },
    {
      path: "SLS02_014RPT.xml",
      component: SLS02_014RPT,
    },
    {
      path: "SLS04_002RPT.xml",
      component: SLS04_002RPT,
    },
    {
      path: "SLS04_031RPT.xml",
      component: SLS04_031RPT,
    },
    {
      path: "SLS04_003RPT.xml",
      component: SLS04_003RPT,
    },
    {
      path: "SLS05_002RPT.xml",
      component: SLS05_002RPT,
    },
    {
      path: "SLS06_002RPT.xml",
      component: SLS06_002RPT,
    },
    {
      path: "SLS06_004RPT.xml",
      component: SLS06_004RPT,
    },
    {
      path: "SLS05_004RPT.xml",
      component: SLS05_004RPT,
    },
    {
      path: "SLS06_001RPT.xml",
      component: SLS06_001RPT,
    },
    {
      path: "SLS04_004RPT.xml",
      component: SLS04_004RPT,
    },
    {
      path: "SLS06_005RPT.xml",
      component: SLS06_005RPT,
    },
    {
      path: "SLS02_017RPT.xml",
      component: SLS02_017RPT,
    },
    {
      path: "SLS02_028RPT.xml",
      component: SLS02_028RPT,
    },
    {
      path: "SLS06_003RPT.xml",
      component: SLS06_003RPT,
    },
    {
      path: "SLS08_001RPT.xml",
      component: SLS08_001RPT,
    },
    {
      path: "SLS08_002RPT.xml",
      component: SLS08_002RPT,
    },
    {
      path: "SLS08_003RPT.xml",
      component: SLS08_003RPT,
    },
    {
      path: "SLS08_004RPT.xml",
      component: SLS08_004RPT,
    },
    {
      path: "SLS08_005RPT.xml",
      component: SLS08_005RPT,
    },
    {
      path: "SLS11_007RPT.xml",
      component: SLS11_007RPT,
    },
    {
      path: "SLS11_006RPT.xml",
      component: SLS11_006RPT,
    },
    {
      path: "SLS11_013RPT.xml",
      component: SLS11_013RPT,
    },
    {
      path: "SLS11_009RPT.xml",
      component: SLS11_009RPT,
    },
    {
      path: "SLS11_012RPT.xml",
      component: SLS11_012RPT,
    },
    {
      path: "SLS11_014RPT.xml",
      component: SLS11_014RPT,
    },
    {
      path: "SLS11_004RPT.xml",
      component: SLS11_004RPT,
    },
    {
      path: "SLS11_008RPT.xml",
      component: SLS11_008RPT,
    },
    {
      path: "SLS12_011RPT.xml",
      component: SLS12_011RPT,
    },
    {
      path: "SLS12_019RPT.xml",
      component: SLS12_019RPT,
    },
    {
      path: "SLS12_020RPT.xml",
      component: SLS12_020RPT,
    },
    {
      path: "SLS14_032RPT.xml",
      component: SLS14_032RPT,
    },
    {
      path: "SLS01_091RPT.xml",
      component: SLS01_091RPT,
    },
    {
      path: "SLS01_092RPT.xml",
      component: SLS01_092RPT,
    },
    {
      path: "SLS02_006RPT.xml",
      component: SLS02_006RPT,
    },
    {
      path: "SLS02_022RPT.xml",
      component: SLS02_022RPT,
    },
    {
      path: "SLS01_093RPT.xml",
      component: SLS01_093RPT,
    },
    {
      path: "SLS01_055RPT.xml",
      component: SLS01_055RPT,
    },
    {
      path: "SLS01_056RPT.xml",
      component: SLS01_056RPT,
    },
    {
      path: "SLS01_057RPT.xml",
      component: SLS01_057RPT,
    },
    {
      path: "SLS02_023RPT.xml",
      component: SLS02_023RPT,
    },
    {
      path: "SLS01_001INS.xml",
      component: SLS01_001INS,
    },
    {
      path: "SLS02_031RPT.xml",
      component: SLS02_031RPT,
    },
    {
      path: "SLS07_006INS.xml",
      component: SLS07_006INS,
    },
    {
      path: "SLS11_010RPT.xml",
      component: SLS11_010RPT,
    },
    {
      path: "SLS11_011RPT.xml",
      component: SLS11_011RPT,
    },
    {
      path: "SLS02_032RPT.xml",
      component: SLS02_032RPT,
    },
    {
      path: "SLS11_017RPT.xml",
      component: SLS11_017RPT,
    },
    {
      path: "SLS04_027RPT.xml",
      component: SLS04_027RPT,
    },
    {
      path: "SLS11_024RPT.xml",
      component: SLS11_024RPT,
    },
    {
      path: "SLS11_025RPT.xml",
      component: SLS11_025RPT,
    },
    {
      path: "SLS04_023RPT.xml",
      component: SLS04_023RPT,
    },
    {
      path: "SLS11_021RPT.xml",
      component: SLS11_021RPT,
    },
    {
      path: "SLS12_002RPT.xml",
      component: SLS12_002RPT,
    },
    {
      path: "SLS14_004RPT.xml",
      component: SLS14_004RPT,
    },
    {
      path: "SLS14_043RPT.xml",
      component: SLS14_043RPT,
    },
    {
      path: "SLS14_044RPT.xml",
      component: SLS14_044RPT,
    },
    {
      path: "SLS11_023RPT.xml",
      component: SLS11_023RPT,
    },
    {
      path: "SLS02_007RPT.xml",
      component: SLS02_007RPT,
    },
    {
      path: "SLS02_008RPT.xml",
      component: SLS02_008RPT,
    },
    {
      path: "SLS16_001RPT.xml",
      component: SLS16_001RPT,
    },
    {
      path: "SLS16_002RPT.xml",
      component: SLS16_002RPT,
    },
    {
      path: "SLS06_013RPT.xml",
      component: SLS06_013RPT,
    }

    
  ];
}
